/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Edit_No_Changes_HintInputs */



/**
* | output |
* | --- |
* | "The assistant read the document in its last reply but did not submit any changes. If it said otherwise, ask it to make the change again." |
*
* @param {Artifact_Edit_No_Changes_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_edit_no_changes_hint = /** @type {((inputs?: Artifact_Edit_No_Changes_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Edit_No_Changes_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die KI hat das Dokument in ihrer letzten Antwort gelesen, aber keine Änderungen eingereicht. Wenn sie etwas anderes behauptet, bitte sie, die Änderung erneut vorzunehmen.")
	return /** @type {LocalizedString} */ ("The assistant read the document in its last reply but did not submit any changes. If it said otherwise, ask it to make the change again.")
});